module.exports = __webpack_public_path__ + "static/media/payhawk-logo.53f8e2db.svg";